import React, { useEffect, useState } from 'react';
import './index.css';
import { useForm } from 'react-hook-form';
import { useMediaQuery } from 'react-responsive';
import { ENDPOINTS } from 'constants/endpoints';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import { LayoutContext } from 'components/app-routes';
import useFlashToggler from 'hooks/use-flash-toggler';
import resolveURLParams from '__utils/url-params-resolver';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import { DetailsCardContainer } from 'views/common-styled-components';
import { PrimarySmallBtn, SuccessBtnWhiteGreenBorder } from 'components/button';
import { addAgentCode, getQueryParamsFromString, MFDetailsPageURLWithEncryptedId } from '__utils/common-utils';
import { get_item_from_localStorage, set_item_in_localStorage } from '__utils/storage';
import styled from 'styled-components';
import { CommonStyledComponentProps } from '__utils/type';


const SearchContainer = styled.div<CommonStyledComponentProps>`
    .searchArticle{
        padding: 15px 0;${(props: any) => props.isMobile ? '30px 0 45px 0' : '15px 0'};
    }
    .searchArticle a {
        color:  ${(props: any) => props.isMobile ? '#031235' : '#1f6dd1'};
        font-weight: ${(props: any) => props.isMobile ? '500' : 'normal'};
    }
    .searchResultTags li span {
        color:  ${(props: any) => props.isMobile ? '#757575' : '#96a9bb'};
        background-color: ${(props: any) => props.isMobile ? '#f5f5f5' : '#ffffff'};
        padding: ${(props: any) => props.isMobile ? '10px 13px' : '6px 15px'};
        font-size: ${(props: any) => props.isMobile ? '13px' : '14px'};
    }
    .searchArticle p {
        color:  ${(props: any) => props.isMobile ? '#757575' : '#96a9bb'};
        margin-bottom: ${(props: any) => props.isMobile ? '20px' : ''};
    }
`
const SearchFundsResult: React.FC = () => {
    const flash = useFlashToggler();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { keywords } = getQueryParamsFromString(window.location.search);
    const { register, handleSubmit } = useForm({ mode: 'onChange' });
    const { SetLayoutProps } = React.useContext(LayoutContext);

    const [mutualFundsResults, setMutualFundsResults] = useState<Array<any>>([]);
    const [searchResult, setSearchResult] = useState<any>();
    const [hasMoreResults, setHasMoreResults] = useState<boolean>(false);
    const [pageNo, setPageNo] = useState<number>(0);


    const updateRecentSearch = (searchTerm: string) => {
        const itemFromStorage = get_item_from_localStorage('recentSearches');
        let recentSearches = itemFromStorage ? JSON.parse(itemFromStorage) : [];
        var index = recentSearches?.indexOf(searchTerm);
        if (index > -1) {
            recentSearches?.splice(index, 1);
        }
        recentSearches?.unshift(searchTerm);
        recentSearches = recentSearches?.slice(0, 5);
        recentSearches && set_item_in_localStorage("recentSearches", JSON.stringify(recentSearches));
    }

    const searchFromInput = (data: any) => {
        setPageNo(0);
        getMFsearchResults(0, data.searchInput);
    }
    const showMoreFunds = () => {
        getMFsearchResults(pageNo + 1, keywords);
        setPageNo(pageNo => pageNo + 1);
    }

    const getMFsearchResults = (pageNo: number, keywords: string) => {
        get(resolveURLParams(ENDPOINTS.GET_SEARCH_MUTUAL_FUNDS_BY_TEXT, { q: keywords, PageNumber: pageNo }, {}), getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {

                if (response?.response) {
                    setSearchResult(response?.response);
                    setMutualFundsResults(pageNo === 0 ? response.response?.content : [...mutualFundsResults, ...response.response?.content]);
                }
                if (response.response?.content.length) {
                    setHasMoreResults(pageNo === (response?.response.totalPages - 1) ? false : true);
                    updateRecentSearch(keywords);
                } else {
                    setHasMoreResults(false);
                }
                SetLayoutProps({
                    config: {
                        title: <p>Search Results <span className='SearchText'>({response?.response?.totalElements} Results)</span></p>,
                    },
                    showCopyrightInfoForDesktop: true,
                    breadcrumbList: [{ text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: `Search Results`, url: '/search', isExternal: false }]
                });
            }, (error: AjaxError) => {
                flash.error('Something went wrong.');
            });
    }

    useEffect(() => {
        getMFsearchResults(pageNo, keywords);
    }, [keywords])

    return <DetailsCardContainer isMobile={isMobile}>
        <SearchContainer isMobile={isMobile}>
            {!isMobile && <div className="searchField group">
                <form onSubmit={handleSubmit(searchFromInput)}>
                    <input
                        name='searchInput'
                        type="text"
                        ref={register()}
                        defaultValue={decodeURIComponent(keywords)}
                        placeholder="Search by fund name, category, sector, risk, fund manager etc."
                    />
                    <PrimarySmallBtn>Search</PrimarySmallBtn>
                </form>

            </div>
            }
            {(!isMobile && searchResult) && <h3 className='result-title'>{searchResult?.totalElements} Results, Fund and Products</h3>}
            {
                mutualFundsResults?.map((mfView: any, index: number) =>
                    <div key={index} className='searchArticle'>
                        <h3><a href={MFDetailsPageURLWithEncryptedId(mfView)}>{mfView?.schemeName}</a></h3>
                        <p>{mfView?.fundInvestmentObjective}</p>
                        <div>
                            <ul className="searchResultTags">
                                {mfView?.category && <li><span>{mfView.category}</span></li>}
                                {mfView?.subCategory && <li><span>{mfView.subCategory}</span></li>}
                                {mfView.riskometer && <li><span>{mfView.riskometer}</span></li>}
                            </ul>
                        </div>
                    </div>)
            }
            {hasMoreResults && <div className="viewMoreFunds" onClick={showMoreFunds}>
                <SuccessBtnWhiteGreenBorder> View more ...</SuccessBtnWhiteGreenBorder>
            </div>}
        </SearchContainer>
    </DetailsCardContainer>;
}

export default SearchFundsResult;

